<script lang="ts">
import EditorStore from "@src/model/Editor.Store";

import InteractionTrack from "./InteractionTrack.svelte";
import TimelineCaret from "./TimelineCaret.svelte";
import TimelineGauge from "./TimelineGauge.svelte";

import TrackHead from "./TrackHead.svelte";
import VideoTrack from "./VideoTrack.svelte";

let trackBodyContainerElement: HTMLDivElement;
function handleTrackBodyContainerScroll(e) {
    EditorStore.getValue().currentTimelineTrackDisplayOffset.set(trackBodyContainerElement.getBoundingClientRect().x);
}


</script>

<div id="ivdemo-timeline">
    <div id="ivdemo-timeline-title">TIMELINE</div>

    <div id="ivdemo-timeline-body"
        on:scroll={handleTrackBodyContainerScroll}
    >
        <TimelineGauge />
        <div id="ivdemo-timeline-track-container">
            <div id="ivdemo-timeline-track-head-container">
                <TrackHead title="VIDEO" />
                <TrackHead title="INTERACTION" />
            </div>
            <div id="ivdemo-timeline-track-body-container"
                bind:this={trackBodyContainerElement}
            >
                <VideoTrack />
                <InteractionTrack />
            </div>
        </div>
        <TimelineCaret />
    </div>
</div>


<style>
    #ivdemo-timeline {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        height: 300px;
        background-color: gray;
    }
    #ivdemo-timeline-title {
        background-color: black;
        color: white;
        border-bottom: 1px #3f3f3f solid;
        font-weight: bold;
        font-size: 0.8rem;
        height: 16px;
    }
    #ivdemo-timeline-body {
        position: fixed;
        overflow-x: scroll;
        overflow-y: auto;
        left: 0;
        right: 0;
        height: calc(300px - 17px);
        scrollbar-color: #333333 black;
    }
    #ivdemo-timeline-track-head-container {
        height: calc(300px - 17px - 2rem);
        background-color: #555555;
        position: fixed;
        z-index: 2200;
    }
    #ivdemo-timeline-track-body-container {
        margin-left: 161px;
    }
    ::-webkit-scrollbar {
        height: 16px;
        background-color: black;
    }
    ::-webkit-scrollbar-thumb {
        height: 16px;
        background-color: #333333;
    }

</style>
